import React, { useContext } from 'react'
import ManagersContext from '../../containers/ManagersContext'
import about from './about.module.less'
import { createAscendingArray } from '../../utils'

export default function InnerPageAbout() {
  const { slideshowManager } = useContext(ManagersContext)
  const aboutSlides = slideshowManager.get('about')
  const numSlides = aboutSlides.imgsArray.length
  const slidesOrder = createAscendingArray(0, numSlides - 1)

  return (
    <div>
      <header>
        <h1>About This Site</h1>
        <p>
          The website{' '}
          <span style={{ fontWeight: 'bold' }}>gregsandell.com</span> is written
          in the React framework with Node.js and TypeScript. A full list of all
          programming languages, tools and software environments used in the
          making are:
        </p>
      </header>
      <div className={about.container}>
        {slidesOrder.map((idx) => {
          const img = aboutSlides.imgsArray[idx]
          return (
            <div key={`slide${idx}`}>
              <img src={`/image/${aboutSlides.imgsSubdir}/${img.file}`} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
